import { render, staticRenderFns } from "./IconEscala.vue?vue&type=template&id=41c45252"
import script from "./IconEscala.vue?vue&type=script&lang=js"
export * from "./IconEscala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports